//import Logger from './Logger';

export const rem2px = rem => {
  const el = document.querySelector('body');
  const style = window.getComputedStyle(el, null).getPropertyValue('font-size');
  const fontSize = parseFloat(style);
  const result = parseFloat(rem) * fontSize;
  return result;
};
